import { cx } from 'emotion';
import { HTMLAttributes, forwardRef } from 'react';

import { isNil } from '@ezugi/utils';

import Icon from '../Icon/Icon';
import {
  StyledButton,
  Label,
  iconClassName,
  disabledClassName,
  denseClassName,
  sparseClassName,
  flexClassName,
  transparentClassName,
  getButtonCusstomClassName,
  upperCaseLabel,
  ICON_SIZE,
  DENSE_ICON_SIZE,
  SPARSE_ICON_SIZE,
} from './style';

const getIconSize = ({ dense, sparse } : {dense: boolean, sparse: boolean}) => {
  switch (true) {
  case dense:
    return DENSE_ICON_SIZE;
  case sparse:
    return SPARSE_ICON_SIZE;
  default:
    return ICON_SIZE;
  }
};

type ButtonProps = {
  label?: string;
  icon?: string;
  dataE2e?: string;
  disabled?: boolean;
  dense?: boolean;
  sparse?: boolean;
  flex?: boolean;
  transparent?: boolean;
  background?: string;
  foreground?: string;
  primary?: boolean;
  accent?: boolean;
  uppercase?: boolean;
  style?: object;
}

const Button = forwardRef<HTMLButtonElement, HTMLAttributes<HTMLButtonElement> & ButtonProps>(
  (
    {
      dataE2e,
      icon,
      disabled = false,
      label,
      dense = false,
      sparse = false,
      flex = false,
      transparent = false,
      children,
      background,
      foreground,
      primary = false,
      accent = false,
      uppercase = false,
      className,
      style = {},
      ...props
    },
    ref
  ) => (
    <StyledButton
      tabIndex={-1}
      {...props}
      disabled={disabled}
      ref={ref}
      className={cx(
        {
          [disabledClassName]: disabled,
          [denseClassName]: dense,
          [sparseClassName]: sparse,
          [transparentClassName]: transparent,
          [flexClassName]: flex,
          [getButtonCusstomClassName({ background, foreground, primary, accent, transparent })]:
            Boolean(primary || accent || background || foreground),
        },
        className
      )}
      style={style}
    >
      {isNil(children) ? (
        <>
          {icon && (
            <Icon
              {...{
                svg: icon,
                size: getIconSize({ dense, sparse }),
              }}
              className={iconClassName}
            />
          )}
          {!isNil(label) && (
            <Label
              data-e2e={dataE2e ?? `btn-label-${label.replace(/\s/g, '-')}`}
              className={cx({ [upperCaseLabel]: uppercase })}
            >
              {label}
            </Label>
          )}
        </>
      ) : (
        children
      )}
    </StyledButton>
  )
);

export default Button;
